'use client';

import React from 'react';

import { useGlobalClientContext } from '../common/GlobalClientContext';

export default function Bottom() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  const interestHref = `/talk-to-expert`;

  return (
    <div className="w-full h-fit bg-gray-900 py-[80px] flex flex-col items-center justify-center">
      <div className="font-display font-semibold text-3xl leading-8xl text-primaryInverse">
        {t('home.bottom.title', {})}
      </div>
      <div className="mt-[16px]font-regular text-xl leading-3xl text-primaryInverse">
        {t('home.bottom.description', {})}
      </div>
      <a
        href={interestHref}
        className="h-[56px] mt-[32px] bg-[#05a8fd] w-fit rounded-[8px] hover:bg-[#0497E4] hover:no-underline active:bg-[#0686C8] px-[22px] py-[16px] font-display font-semibold text-lg leading-lg text-primaryInverse">
        {t('talk_to_expert.capitalize', {})}
      </a>
    </div>
  );
}
